import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';

const ClaimId = (cell) => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ''}
    </Link>
  );
};

const BillingName = (cell) => {
  return cell.value ? cell.value : '';
};

const Date = (cell) => {
  return cell.value ? cell.value : '';
};

const Total = (cell) => {
  return cell.value ? cell.value : '';
};

const PaymentStatus = ({ value }) => {
  const statusColors = {
    Open: "primary",
    Revise: "warning",
    Closed: "secondary",
    Approved: "success",
    SUCCESS: "success",
    Reported: "info",
    Payment: "success",
    NEW: "purple",
    PAYING: "warning",
    Inactive: "dark",
    Rejected: "danger",
    Released: "info",
  };

  const color = statusColors[value] || "light";
  const label = value === "Inactive" ? "Inactive (On Hold)" : value;

  return (
    <Badge className={`font-size-12 badge-soft-${color}`}>
      {label}
    </Badge>
  );
};

const PaymentMethod = (cell) => {
  return (
    <span>
      <i
        className={
          cell.value === 'Paypal'
            ? 'fab fa-cc-paypal me-1'
            : '' || cell.value === 'COD'
            ? 'fab fas fa-money-bill-alt me-1'
            : '' || cell.value === 'Mastercard'
            ? 'fab fa-cc-mastercard me-1'
            : '' || cell.value === 'Visa'
            ? 'fab fa-cc-visa me-1'
            : ''
        }
      />{' '}
      {cell.value}
    </span>
  );
};
export { ClaimId, BillingName, Date, Total, PaymentStatus, PaymentMethod };
